import React, { ComponentProps } from "react";

export default function WalletClosedIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_4725_423976)">
        <path
          d="M16.328 6.07383C16.328 3.91992 18.0804 2.16758 20.2343 2.16758H21.5862L21.1784 1.03398C20.9491 0.396484 20.3483 0 19.708 0C19.5305 0 19.3501 0.0304687 19.1737 0.0946875L5.51328 5.06664C4.70117 5.36227 4.2832 6.26094 4.58055 7.07242L5.30235 9.04258H16.328V6.07383Z"
          fill="#6C53E8"
        />
        <path
          d="M20.2344 4.51123C19.3714 4.51123 18.6719 5.21076 18.6719 6.07373V9.04248H32.3438V6.07373C32.3438 5.21076 31.6442 4.51123 30.7812 4.51123H20.2344Z"
          fill="#6C53E8"
        />
        <path
          d="M36.4844 31.5815H31.0156C27.7848 31.5815 25.1562 28.953 25.1562 25.7222C25.1562 22.4913 27.7848 19.8628 31.0156 19.8628H36.4844V14.5112C36.4844 12.7854 35.0852 11.3862 33.3594 11.3862H3.125C1.39914 11.3862 0 12.7854 0 14.5112V36.8749C0 38.6008 1.39914 39.9999 3.125 39.9999H33.3594C35.0852 39.9999 36.4844 38.6008 36.4844 36.8749V31.5815Z"
          fill="#6C53E8"
        />
        <path
          d="M38.8281 22.2065H31.0156C29.0771 22.2065 27.5 23.7837 27.5 25.7222C27.5 27.6607 29.0771 29.2378 31.0156 29.2378H38.8281C39.4743 29.2378 40 28.7121 40 28.0659V23.3784C40 22.7322 39.4743 22.2065 38.8281 22.2065ZM31.0156 26.894C30.3684 26.894 29.8438 26.3694 29.8438 25.7222C29.8438 25.075 30.3684 24.5503 31.0156 24.5503C31.6628 24.5503 32.1875 25.075 32.1875 25.7222C32.1875 26.3694 31.6628 26.894 31.0156 26.894Z"
          fill="#6C53E8"
        />
      </g>
      <defs>
        <clipPath id="clip0_4725_423976">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
